import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import Vue from "vue/dist/vue.js";

export default class BlogListing {
  constructor() {
    console.log("BlogListing :: init");

    new Vue({
      el: "#blog-listing",
      data() {
        return {
          blogLength: 6,
          blogs: [],
          msnry: "",
        };
      },
      mounted() {
        this.blogs = this.$refs.listing.querySelectorAll(".bloc-post");
        this.activateMasonry();
      },
      methods: {
        loadmore() {
          this.blogLength += 3;
          this.showBlogs();
        },
        showBlogs() {
          for (let i = 0; i < this.blogs.length; i++) {
            if (i > this.blogLength - 1) {
              this.blogs[i].style.display = "none";
            } else {
              this.blogs[i].style.display = "";
            }
          }

          if (this.blogLength >= this.blogs.length) {
            this.$refs.loadmore.style.display = "none";
          }
          this.msnry.layout();
        },
        activateMasonry() {
          imagesLoaded(".blog-list", (instance) => {
            this.msnry = new Masonry(".blog-list", {
              itemSelector: ".bloc-post",
              percentPosition: true,
              columnWidth: ".bloc-post",
              gutter: ".gutter-sizer",
            });
            //remove opacity class
            document
              .querySelector(".blog-list")
              .classList.remove("transparent");
            this.showBlogs();
          });
        },
      },
    });
  }
}
